import React from "react";
import { createUseStyles } from "react-jss";
import { LazyImage } from "react-lazy-images";

const useStyles = createUseStyles((theme) => ({
	imgMarginBottom: {
		marginBottom: "15px",
	},
	descriptionItem: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "center",
		width: "calc(50% - 13.5px)",
		fontSize: "12px",
		lineHeight: "14.4px",
		fontWeight: 300,
		textAlign: "center",
		color: theme.palette.colors.oneMoreGrey,
	},
	descriptionItem100: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "center",
		width: "100%",
		fontSize: "12px",
		lineHeight: "14.4px",
		fontWeight: 300,
		textAlign: "center",
		color: theme.palette.colors.oneMoreGrey,
	},
}));

function VariantTemplateBlock({ children, img, descriptionItemProps }) {
	const urlCdn = "https://c3591b9e-55d5-464e-a0bd-e98367d2d7f8.selstorage.ru";
	const { imgMarginBottom, descriptionItem, descriptionItem100 } = useStyles();

	return (
		<li className={descriptionItemProps ? descriptionItem100 : descriptionItem}>
			<LazyImage
				src={`${urlCdn}${img}`}
				placeholder={({ imageProps, ref }) => <img ref={ref} className={imgMarginBottom} />}
				actual={({ imageProps }) => (
					<img {...imageProps} alt={"инфографика"} className={imgMarginBottom} />
				)}
			/>
			{children}
		</li>
	);
}

export default VariantTemplateBlock;
